import React from "react";

const Line = () => {
  return (
    <div className="bg-gradient-to-r from-primary to-secondary lg:w-[80px] 2xl:w-[120px] h-[3px] shrink-0 hidden lg:flex self-center"></div>
  );
};

const Bubble = ({ title, index }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <div className="rounded-full flex w-8 h-8 md:w-10 md:h-10 lg:w-16 lg:h-16 shrink-0 items-center justify-center border-3 border-primary bg-white shadow-md hover:shadow-lg transition-shadow">
        <p className="font-oswald text-base sm:text-lg lg:text-2xl font-bold text-primary">
          {index}
        </p>
      </div>
      <p className="font-poppins text-xs w-[70px] md:w-full sm:text-sm lg:text-base font-semibold text-gray-800 lg:w-[120px] text-center">
        {title}
      </p>
    </div>
  );
};

const StepWiseGuide = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full max-w-screen-xl px-4 mb-2 mt-8 md:mt-12">
      <div className="flex flex-row items-center justify-center gap-3 md:gap-4 mb-6">
        <Bubble title="Your Details" index="1" />
        <Line />
        <Bubble title="Make Transaction" index="2" />
        <Line />
        <Bubble title="Access Unlocked" index="3" />
      </div>
      <div className="text-center space-y-1">
        <p className="font-poppins text-sm md:text-base text-gray-700 font-medium">
          Takes less than a minute
        </p>
      </div>
    </div>
  );
};

export default StepWiseGuide;
